import { SystemHeader, SystemTitle } from "../../../lib";
import React from "react";

export default () =>
  (<SystemHeader>
    <SystemTitle title="hello world"/>
  </SystemHeader>);



// WEBPACK FOOTER //
// ./src/SystemHeader/SystemHeader/demo/withLabel.js